import { useGetPackageOffersAndFlightOptions } from '../useGetPackageOffersAndFlightOptions';
import { calculateNumberOfPages } from './utils/calculateNumberOfPages';
import { getFlightOptions } from './utils/getFlightOptions';

// NOTE: all paginated data is only relevant for return journey (international)
// flights. For split journey (domestic) flights the pagination isn't used, we
// just use the first 'page'.
export const useFlightOptions = () => {
  const {
    paginatedData,
    error,
    isValidSearchQuery,
    size: currentPage,
    setSize: setCurrentPage,
    flightOptionsLimit,
  } = useGetPackageOffersAndFlightOptions();

  const flightOptions = getFlightOptions(paginatedData);
  const numberOfPages = calculateNumberOfPages(
    paginatedData,
    flightOptionsLimit,
  );
  const isPagesLeftToLoad = currentPage < numberOfPages;
  const numberOfLoadedPages = paginatedData?.length ?? 0;
  const isLoading =
    !!isValidSearchQuery && !error && currentPage > numberOfLoadedPages;
  const loadNextFlightsPage = () => {
    if (isPagesLeftToLoad) {
      return setCurrentPage((page) => page + 1);
    }
  };

  return {
    flightOptions,
    totalFlightOptions: paginatedData?.[0]?.totalFlightOptions,
    numberOfPages,
    isPagesLeftToLoad,
    loadNextFlightsPage,
    isLoading,
  };
};
